module.exports = __webpack_public_path__ + "img/PrivacyPolicy_Collapsed_Small_Button.ac204698.svg";